const origin = window.location.origin.includes('kpxt') ? '/home' : '/customer/relationship'
export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  BASE_MODIFYPSW = '/modifyPsw',
  // basic home path
  // BASE_HOME = '/dashboard', // 去除首页
  // BASE_HOME = '/customer/relationship',
  BASE_HOME = origin,
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  MESSAGE_PAGE = '/profile/notify-message',
}

export const PageWrapperFixedHeightKey = 'PageWrapperFixedHeight'
